import { render, staticRenderFns } from "./TransactionsTableV2.vue?vue&type=template&id=9f17a6f0&"
import script from "./TransactionsTableV2.vue?vue&type=script&lang=js&"
export * from "./TransactionsTableV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports